// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.other-buyer{margin:30px}label[for=differentBuyer]{margin-top:30px}`, "",{"version":3,"sources":["webpack://./src/components/subscription/OtherBuyer.scss"],"names":[],"mappings":"AAAA,aACI,WAAA,CAOJ,0BACI,eAAA","sourcesContent":[".other-buyer {\n    margin: 30px;\n}\n\nform.checkout {\n\n}\n\nlabel[for=differentBuyer] {\n    margin-top: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
